export default {"root":"ryQdW","title":"_1RMnd","summary":"tjuhM","footer":"hByz-"};